/**
 * Thin wrapper that mounts ReportsTabCN scoped to the current project.
 *
 * Linear: MYD-339 (Phase 2).
 */

import { useParams } from 'react-router-dom'
import ReportsTabCN from 'features/Reports/ReportsTabCN'

const ProjectReports = () => {
	const { id } = useParams<{ id: string }>()
	if (!id) return null
	return (
		<ReportsTabCN
			scope="project"
			entityId={id}
			heading="Project reports"
			subhead="Generate a one-page Snapshot for partner sharing, or a multi-page Story for quarterly reviews and closeout packages. Reports land here and on the Documents tab."
		/>
	)
}

export default ProjectReports
